(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  /*
    Hover intent for the desktop menus (mouse only). Dawn's <details>/<summary> disclosure stays the
    source of truth: click, Enter and Space still toggle it and Esc closes it. A panel opened by hover
    waits ~200 ms before opening, switches faster once a menu is open, and stays open for ~400 ms after
    the pointer leaves so a diagonal path to the panel does not close it.
    Opening needs real pointer movement over a menu: browsers also fire pointerenter (and sometimes a
    pointermove at the same position) when the page scrolls or the sticky header slides under a cursor
    that is resting still, and that must not pop a panel open.
  */
  class VmMegaNav extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.menus = Array.from(this.querySelectorAll('header-menu'));
      this.openTimer = null;
      this.closeTimer = null;
      this.pendingMenu = null;
      this.lastPointer = null;

      this.menus.forEach((menu) => {
        const details = menu.querySelector('details');
        const summary = details && details.querySelector('summary');
        if (!summary || menu.dataset.vmHoverBound) return;
        menu.dataset.vmHoverBound = 'true';

        // Entering a menu only cancels a pending close; opening is driven by onPointerMove.
        menu.addEventListener('pointerenter', (event) => {
          if (!this.isHoverMouse(event)) return;
          window.clearTimeout(this.closeTimer);
        });
        menu.addEventListener('pointerleave', (event) => {
          if (!this.isHoverMouse(event)) return;
          this.scheduleClose();
        });
        details.addEventListener(
          'click',
          (event) => {
            if (!summary.contains(event.target)) return;
            // A click decides on its own: a pending hover-open must not fire afterwards and re-mark the panel.
            this.cancelOpen();
            if (details.dataset.vmHover === 'true') {
              // A click right after a hover-open commits the panel instead of toggling it shut.
              event.preventDefault();
              event.stopPropagation();
              delete details.dataset.vmHover;
              summary.setAttribute('aria-expanded', 'true');
              return;
            }
            // Opening by click: close a hover-opened neighbour (focus was never in it, so Dawn's focusout won't).
            if (!details.open) this.closeOthers(menu);
          },
          true
        );
        details.addEventListener('toggle', () => {
          if (!details.open) delete details.dataset.vmHover;
        });
      });

      this.onPointerMove = (event) => {
        if (event.pointerType !== 'mouse') return;
        const last = this.lastPointer;
        this.lastPointer = { x: event.clientX, y: event.clientY };
        // Skip the first sample and any move that did not change the pointer position.
        if (!last || (last.x === event.clientX && last.y === event.clientY)) return;
        if (!this.mq.matches || !(event.target instanceof Element)) return;
        const menu = event.target.closest('header-menu');
        if (!menu || !this.menus.includes(menu)) return;
        const details = menu.querySelector('details');
        if (details) this.scheduleOpen(menu, details);
      };
      document.addEventListener('pointermove', this.onPointerMove, { passive: true });

      this.onKeyDown = (event) => {
        if (event.key !== 'Escape') return;
        this.cancelOpen();
        this.menus.forEach((menu) => {
          const details = menu.querySelector('details');
          if (!details || !details.open || details.dataset.vmHover !== 'true') return;
          // Dawn's keyup handler finds no open panel after this, so bring focus back to the summary ourselves.
          const hadFocus = details.contains(document.activeElement);
          this.closeMenu(menu, details);
          if (hadFocus) details.querySelector('summary').focus();
        });
      };
      document.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('pointermove', this.onPointerMove);
      this.cancelOpen();
      window.clearTimeout(this.closeTimer);
    }

    isHoverMouse(event) {
      return event.pointerType === 'mouse' && this.mq.matches;
    }

    // Called on every real pointer move over a menu: keeps an already pending open on its original schedule.
    scheduleOpen(menu, details) {
      window.clearTimeout(this.closeTimer);
      if (details.open || this.pendingMenu === menu) return;
      this.cancelOpen();
      const anotherIsOpen = this.menus.some((other) => other !== menu && other.querySelector('details[open]'));
      this.pendingMenu = menu;
      this.openTimer = window.setTimeout(() => this.openMenu(menu, details), anotherIsOpen ? 120 : 200);
    }

    cancelOpen() {
      window.clearTimeout(this.openTimer);
      this.pendingMenu = null;
    }

    // Leaving any menu closes every hover-opened panel after the grace period,
    // unless the pointer comes back to a menu or keyboard focus is inside the panel.
    scheduleClose() {
      this.cancelOpen();
      window.clearTimeout(this.closeTimer);
      this.closeTimer = window.setTimeout(() => {
        this.menus.forEach((menu) => {
          const details = menu.querySelector('details');
          if (!details || !details.open || details.dataset.vmHover !== 'true') return;
          if (details.contains(document.activeElement)) return;
          this.closeMenu(menu, details);
        });
      }, 400);
    }

    openMenu(menu, details) {
      this.pendingMenu = null;
      // Opened by a click or the keyboard in the meantime: that panel belongs to Dawn's disclosure.
      if (details.open) return;
      this.closeOthers(menu);
      details.dataset.vmHover = 'true';
      details.open = true;
      details.querySelector('summary').setAttribute('aria-expanded', 'true');
    }

    closeOthers(menu) {
      this.menus.forEach((other) => {
        if (other === menu) return;
        const otherDetails = other.querySelector('details');
        if (otherDetails && otherDetails.open) this.closeMenu(other, otherDetails);
      });
    }

    closeMenu(menu, details) {
      delete details.dataset.vmHover;
      if (typeof menu.close === 'function') {
        menu.close();
      } else {
        details.open = false;
        details.querySelector('summary').setAttribute('aria-expanded', 'false');
      }
    }
  }

  if (!customElements.get('vm-mega-nav')) customElements.define('vm-mega-nav', VmMegaNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  if (!customElements.get('vm-read-more')) {
    class VmReadMore extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-read-more-content]');
        this.button = this.querySelector('[data-read-more-toggle]');
        if (!this.content || !this.button || this.ready) return;
        this.ready = true;
        this.classList.add('is-enhanced');
        this.button.addEventListener('click', () => this.toggle());
        this.measure = this.measure.bind(this);
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.measure);
          this.observer.observe(this.content);
        }
        this.measure();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      measure() {
        if (this.classList.contains('is-open')) return;
        this.button.hidden = this.content.scrollHeight <= this.content.clientHeight + 1;
      }

      toggle() {
        const open = !this.classList.contains('is-open');
        this.classList.toggle('is-open', open);
        this.button.setAttribute('aria-expanded', String(open));
        this.button.textContent = open ? this.button.dataset.labelLess : this.button.dataset.labelMore;
        if (!open) this.measure();
      }
    }

    customElements.define('vm-read-more', VmReadMore);
  }

  } catch(e) { console.error(e); }
})();
})();
